module.exports = __webpack_public_path__ + "img/insurance-quotes.7b589573.svg";